module.exports = __webpack_public_path__ + "static/media/Jacqueline-realEstate_160px.81c6058f.jpg";